import gql from "graphql-tag";

export default gql`
  query ncesSchool($id: ID!) {
    ncesSchool(id: $id) {
      name
      address
      isCharter
      district {
        name
        schools {
          id
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/SchoolRegistration/gql/ncesSchool.query.js